import React, { useRef } from "react";
import Image from "next/image";
import styles from "./infrastructure.module.css";
import annanagar1 from "../../assets/images/infrastructure/annanagar1.webp";
import annanagar2 from "../../assets/images/infrastructure/annanagar2.webp";
import annanagar3 from "../../assets/images/infrastructure/annanagar3.webp";
import adyar1 from "../../assets/images/infrastructure/adyar1.webp";
import adyar2 from "../../assets/images/infrastructure/adyar2.webp";
import adyar3 from "../../assets/images/infrastructure/adyar3.webp";
import adyar4 from "../../assets/images/infrastructure/adyar4.webp";
import adyar5 from "../../assets/images/infrastructure/adyar5.webp";
import adyar6 from "../../assets/images/infrastructure/adyar6.webp";
import adyar7 from "../../assets/images/infrastructure/adyar7.webp";
import adyar8 from "../../assets/images/infrastructure/adyar8.webp";
import adyar9 from "../../assets/images/infrastructure/adyar9.webp";
import adyar10 from "../../assets/images/infrastructure/adyar10.webp";
import adyar11 from "../../assets/images/infrastructure/adyar11.webp";
import adyar12 from "../../assets/images/infrastructure/adyar12.webp";
import adyar13 from "../../assets/images/infrastructure/adyar13.webp";
import adyar14 from "../../assets/images/infrastructure/adyar14.webp";
import adyar15 from "../../assets/images/infrastructure/adyar15.webp";
import adyar16 from "../../assets/images/infrastructure/adyar16.webp";
import bengaluru1 from "../../assets/images/infrastructure/bengaluru1.webp";
import bengaluru2 from "../../assets/images/infrastructure/bengaluru2.webp";
import bengaluru3 from "../../assets/images/infrastructure/bengaluru3.webp";
import bengaluru4 from "../../assets/images/infrastructure/bengaluru4.webp";
import bengaluru5 from "../../assets/images/infrastructure/bengaluru5.webp";
import coimbatore1 from "../../assets/images/infrastructure/coimbatore1.webp";
import coimbatore2 from "../../assets/images/infrastructure/coimbatore2.webp";
import coimbatore3 from "../../assets/images/infrastructure/coimbatore3.webp";
import coimbatore4 from "../../assets/images/infrastructure/coimbatore4.webp";
import coimbatore5 from "../../assets/images/infrastructure/coimbatore5.webp";
import coimbatore6 from "../../assets/images/infrastructure/coimbatore6.webp";
import coimbatore7 from "../../assets/images/infrastructure/coimbatore7.webp";
import coimbatore8 from "../../assets/images/infrastructure/coimbatore8.webp";
import coimbatore9 from "../../assets/images/infrastructure/coimbatore9.webp";
import coimbatore10 from "../../assets/images/infrastructure/coimbatore10.webp";
import coimbatore11 from "../../assets/images/infrastructure/coimbatore11.webp";
import coimbatore12 from "../../assets/images/infrastructure/coimbatore12.webp";
import delhi1 from "../../assets/images/infrastructure/delhi1.webp";
import delhi2 from "../../assets/images/infrastructure/delhi2.webp";
import trivandrum1 from "../../assets/images/infrastructure/trivandrum1.webp";
import trivandrum2 from "../../assets/images/infrastructure/trivandrum2.webp";
import trivandrum3 from "../../assets/images/infrastructure/trivandrum3.webp";
import trivandrum4 from "../../assets/images/infrastructure/trivandrum4.webp";
import trivandrum5 from "../../assets/images/infrastructure/trivandrum5.webp";
import trivandrum6 from "../../assets/images/infrastructure/trivandrum6.webp";
import trivandrum7 from "../../assets/images/infrastructure/trivandrum7.webp";
import trivandrum8 from "../../assets/images/infrastructure/trivandrum8.webp";
import trivandrum9 from "../../assets/images/infrastructure/trivandrum9.webp";
import trivandrum10 from "../../assets/images/infrastructure/trivandrum10.webp";
import namakkal1 from "../../assets/images/infrastructure/Namakkal1.webp";
import hostel from "../../assets/images/infrastructure/hostel.svg";
import money from "../../assets/images/infrastructure/money.svg";
import hostel1 from "../../assets/images/infrastructure/hostel1.svg";
import help from "../../assets/images/infrastructure/help.svg";
import check from "../../assets/images/upsc/check.svg";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import Carousel from 'react-bootstrap/Carousel';
import { useState} from "react";

const Infrastructure = () => {
  
  const [indexAll, setIndexAll] = useState(0);
  const [indexAnnanagar, setIndexAnnanagar] = useState(0);
  const [indexAdyar, setIndexAdyar] = useState(0);
  const [indexBengaluru, setIndexBengaluru] = useState(0);
  const [indexCoimbatore, setIndexCoimbatore] = useState(0);
  const [indexDelhi, setIndexDelhi] = useState(0);
  const [indexThiruvananthapuram, setIndexThiruvananthapuram] = useState(0);
  const [indexNamakkal, setIndexNamakkal] = useState(0);

  const handleSelect1 = (selectedIndex, e) => {
    setIndexAll(selectedIndex);
  };
  const handleSelect2 = (selectedIndex, e) => {
    setIndexAnnanagar(selectedIndex);
  };
  const handleSelect3 = (selectedIndex, e) => {
    setIndexAdyar(selectedIndex);
  };
  const handleSelect4 = (selectedIndex, e) => {
    setIndexBengaluru(selectedIndex);
  };
  const handleSelect5 = (selectedIndex, e) => {
    setIndexCoimbatore(selectedIndex);
  };
  const handleSelect6 = (selectedIndex, e) => {
    setIndexDelhi(selectedIndex);
  };
  const handleSelect7 = (selectedIndex, e) => {
    setIndexThiruvananthapuram(selectedIndex);
  };
  const handleSelect8 = (selectedIndex, e) => {
    setIndexNamakkal(selectedIndex);
  };

  const viewallimagesarray = [
  { image:annanagar1, alt: "annanagar1", title:"Annanagarimages", id: "1" },
  {image:annanagar2,alt:"annanagar2", title:"Annanagarimages", id:"2"},
  {image:annanagar3,alt:"annanagar3", title:"Annanagarimages", id:"3"},
  {image:adyar1,alt:"adyar1", title:"Adyarimages", id:"4"},
  {image:adyar2,alt:"adyar2", title:"Adyarimages", id:"5"},
  {image:adyar3,alt:"adyar3", title:"Adyarimages", id:"6"},
  {image:adyar4,alt:"adyar4", title:"Adyarimages", id:"7"},
  {image:adyar5,alt:"adyar5", title:"Adyarimages", id:"8"},
  {image:adyar6,alt:"adyar6", title:"Adyarimages", id:"9"},
  {image:adyar7,alt:"adyar7", title:"Adyarimages", id:"10"},
  {image:adyar8,alt:"adyar8", title:"Adyarimages", id:"11"},
  {image:adyar9,alt:"adyar9", title:"Adyarimages", id:"12"},
  {image:adyar10,alt:"adyar10", title:"Adyarimages", id:"13"},
  {image:adyar11,alt:"adyar11", title:"Adyarimages", id:"14"},
  {image:adyar12,alt:"adyar12", title:"Adyarimages", id:"15"},
  {image:adyar13,alt:"adyar13", title:"Adyarimages", id:"16"},
  {image:adyar14,alt:"adyar14", title:"Adyarimages", id:"17"},
  {image:adyar15,alt:"adyar15", title:"Adyarimages", id:"18"},
  {image:adyar16,alt:"adyar16", title:"Adyarimages", id:"19"},
  {image:bengaluru1,alt:"bengaluru1", title:"Bangaloreimages", id:"20"},
  {image:bengaluru2,alt:"bengaluru2", title:"Bangaloreimages", id:"21"},
  {image:bengaluru3,alt:"bengaluru3", title:"Bangaloreimages", id:"22"},
  {image:bengaluru4,alt:"bengaluru4", title:"Bangaloreimages", id:"23"},
  {image:bengaluru5,alt:"bengaluru5", title:"Bangaloreimages", id:"24"},
  {image:coimbatore1,alt:"coimbatore1", title:"Coimbatoreimages", id:"25"},
  {image:coimbatore2,alt:"coimbatore2", title:"Coimbatoreimages", id:"26"},
  {image:coimbatore3,alt:"coimbatore3", title:"Coimbatoreimages", id:"27"},
  {image:coimbatore4,alt:"coimbatore4", title:"Coimbatoreimages", id:"28"},
  {image:coimbatore5,alt:"coimbatore5", title:"Coimbatoreimages", id:"29"},
  {image:coimbatore6,alt:"coimbatore6", title:"Coimbatoreimages", id:"30"},
  {image:coimbatore7,alt:"coimbatore7", title:"Coimbatoreimages", id:"31"},
  {image:coimbatore9,alt:"coimbatore9", title:"Coimbatoreimages", id:"33"},
  {image:coimbatore10,alt:"coimbatore10", title:"Coimbatoreimages", id:"34"},
  {image:coimbatore11,alt:"coimbatore11", title:"Coimbatoreimages", id:"35"},
  {image:coimbatore12,alt:"coimbatore12", title:"Coimbatoreimages", id:"36"},
  {image:delhi1,alt:"delhi1",title:"Delhiimages", id:"37"},
  {image:delhi2,alt:"delhi2",title:"Delhiimages", id:"38"},
  {image:trivandrum1,alt:"trivandrum1", title:"Trivandrumimages", id:"39"},
  {image:trivandrum2,alt:"trivandrum2", title:"Trivandrumimages", id:"40"},
  {image:trivandrum3,alt:"trivandrum3", title:"Trivandrumimages", id:"41"},
  {image:trivandrum4,alt:"trivandrum4", title:"Trivandrumimages", id:"42"},
  {image:trivandrum5,alt:"trivandrum5", title:"Trivandrumimages", id:"43"},
  {image:trivandrum6,alt:"trivandrum6", title:"Trivandrumimages", id:"44"},
  {image:trivandrum7,alt:"trivandrum7", title:"Trivandrumimages", id:"45"},
  {image:trivandrum8,alt:"trivandrum8", title:"Trivandrumimages", id:"46"},
  {image:trivandrum9,alt:"trivandrum9", title:"Trivandrumimages", id:"47"},
  {image:trivandrum10,alt:"trivandrum10", title:"Trivandrumimages", id:"48"},
  {image:namakkal1,alt:"namakkal1", title:"Namakkalimages", id:"49"},
  {image:coimbatore8,alt:"coimbatore8", title:"Coimbatoreimages", id:"50"},
  
]
const annanagarimagesarray = [
  { image:annanagar1, alt: "annanagar1", title:"Annanagarimages", id: "1" },
  {image:annanagar2,alt:"annanagar2", title:"Annanagarimages", id:"2"},
  {image:annanagar3,alt:"annanagar3", title:"Annanagarimages", id:"3"}
]
const adayarimagesarray = [
  {image:adyar1,alt:"adyar1", title:"Adyarimages", id:"1"},
  {image:adyar2,alt:"adyar2", title:"Adyarimages", id:"2"},
  {image:adyar3,alt:"adyar3", title:"Adyarimages", id:"3"},
  {image:adyar4,alt:"adyar4", title:"Adyarimages", id:"4"},
  {image:adyar5,alt:"adyar5", title:"Adyarimages", id:"5"},
  {image:adyar6,alt:"adyar6", title:"Adyarimages", id:"6"},
  {image:adyar7,alt:"adyar7", title:"Adyarimages", id:"7"},
  {image:adyar8,alt:"adyar8", title:"Adyarimages", id:"8"},
  {image:adyar9,alt:"adyar9", title:"Adyarimages", id:"9"},
  {image:adyar10,alt:"adyar10", title:"Adyarimages", id:"10"},
  {image:adyar11,alt:"adyar11", title:"Adyarimages", id:"11"},
  {image:adyar12,alt:"adyar12", title:"Adyarimages", id:"12"},
  {image:adyar13,alt:"adyar13", title:"Adyarimages", id:"13"},
  {image:adyar14,alt:"adyar14", title:"Adyarimages", id:"14"},
  {image:adyar15,alt:"adyar15", title:"Adyarimages", id:"15"},
  {image:adyar16,alt:"adyar16", title:"Adyarimages", id:"16"}
]
const bengaluruimagesarray = [
  {image:bengaluru1,alt:"bengaluru1",title:"Bangaloreimages",id:"1"},
  {image:bengaluru2,alt:"bengaluru2",title:"Bangaloreimages",id:"2"},
  {image:bengaluru3,alt:"bengaluru3",title:"Bangaloreimages",id:"3"},
  {image:bengaluru4,alt:"bengaluru4",title:"Bangaloreimages",id:"4"},
  {image:bengaluru5,alt:"bengaluru5",title:"Bangaloreimages",id:"5"}
]
const coimbatoreimagesarray = [
  {image:coimbatore1,alt:"coimbatore1",title:"Coimbatoreimages",id:"1"},
  {image:coimbatore2,alt:"coimbatore2",title:"Coimbatoreimages",id:"2"},
  {image:coimbatore3,alt:"coimbatore3",title:"Coimbatoreimages",id:"3"},
  {image:coimbatore4,alt:"coimbatore4",title:"Coimbatoreimages",id:"4"},
  {image:coimbatore5,alt:"coimbatore5",title:"Coimbatoreimages",id:"5"},
  {image:coimbatore6,alt:"coimbatore6",title:"Coimbatoreimages",id:"6"},
  {image:coimbatore7,alt:"coimbatore7",title:"Coimbatoreimages",id:"7"},
  {image:coimbatore9,alt:"coimbatore9",title:"Coimbatoreimages",id:"9"},
  {image:coimbatore10,alt:"coimbatore10",title:"Coimbatoreimages",id:"10"},
  {image:coimbatore11,alt:"coimbatore11",title:"Coimbatoreimages",id:"11"},
  {image:coimbatore12,alt:"coimbatore12",title:"Coimbatoreimages",id:"12"},
  {image:coimbatore8,alt:"coimbatore8", title:"Coimbatoreimages", id:"13"},

]
const delhiimagesarray = [
  { image:delhi1, alt: "delhi1",title:"Delhiimages",id: "1" },
  {image:delhi2,alt:"delhi2",title:"Delhiimages",id:"2"}
]
const trivandrumimagesarray = [
  {image:trivandrum1,alt:"trivandrum1",title:"Trivandrumimages",id:"1"},
  {image:trivandrum2,alt:"trivandrum2",title:"Trivandrumimages",id:"2"},
  {image:trivandrum3,alt:"trivandrum3",title:"Trivandrumimages",id:"3"},
  {image:trivandrum4,alt:"trivandrum4",title:"Trivandrumimages",id:"4"},
  {image:trivandrum5,alt:"trivandrum5",title:"Trivandrumimages",id:"5"},
  {image:trivandrum6,alt:"trivandrum6",title:"Trivandrumimages",id:"6"},
  {image:trivandrum7,alt:"trivandrum7",title:"Trivandrumimages",id:"7"},
  {image:trivandrum8,alt:"trivandrum8",title:"Trivandrumimages",id:"8"},
  {image:trivandrum9,alt:"trivandrum9",title:"Trivandrumimages",id:"9"},
  {image:trivandrum10,alt:"trivandrum10",title:"Trivandrumimages",id:"10"}
]
const namakkalimagesarray = [
  { image:namakkal1, alt: "namakkal1",title:"Namakkalimages", id: "1" }
]

return (
  <>
    
    <Navbar title="about" />

    {/* Infrastructure */}
    <div className={`${styles.tabsection}`}>
    <div className="container">
      <div className="row">
        <div className="col pt-4">
          <h1 className={`${styles.pagemaintitle}`}>Infrastructure</h1>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="row">
        <div className="col">

          <div className={`${styles.tabscrollclass} nav nav-pills mb-3 align-items-baseline`}>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4 active" data-bs-toggle="pill" data-bs-target="#centre-1" type="button" role="tab" aria-controls="centre-1" aria-selected="true">View All</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-2" type="button" role="tab" aria-controls="centre-2" aria-selected="false">Anna Nagar</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-3" type="button" role="tab" aria-controls="centre-3" aria-selected="false">Adyar</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-4" type="button" role="tab" aria-controls="centre-4" aria-selected="false">Bengaluru</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-5" type="button" role="tab" aria-controls="centre-5" aria-selected="false">Coimbatore</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-6" type="button" role="tab" aria-controls="centre-6" aria-selected="false">Delhi</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-7" type="button" role="tab" aria-controls="centre-7" aria-selected="false">Thiruvananthapuram</button>
            <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-8" type="button" role="tab" aria-controls="centre-8" aria-selected="false">Namakkal</button>
          </div>

        </div>
      </div>
    </div>
    </div>

    <div className={`${styles.imagee}`}>
    <div className="tab-content">

{/* View All */}
<div className="tab-pane active" id="centre-1">

  <div className="container gallery">
    <div className="row pt-4">


{/* Modal */}
<div
className="modal fade"
id="SubcriptionConfirmationModal1"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      <Carousel activeIndex={indexAll} onSelect={handleSelect1} indicators={false}>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={annanagar1} className="d-block w-100 h-100 img-fluid" alt="annanagar1" title="Annanagarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={annanagar2} className="d-block w-100 h-100 img-fluid" alt="annanagar2" title="Annanagarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={annanagar3} className="d-block w-100 h-100 img-fluid" alt="annanagar3" title="Annanagarimages" id="carouselimagewidth"/>
              </div>
            </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={adyar1} className="d-block w-100 h-100 img-fluid" alt="adyar1" title="Adyarimages" id="carouselimagewidth"/>
              </div>
            </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={adyar2} className="d-block w-100 h-100 img-fluid" alt="adyar2" title="Adyarimages" id="carouselimagewidth"/>
              </div>
            </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={adyar3} className="d-block w-100 h-100 img-fluid" alt="adyar3" title="Adyarimages" id="carouselimagewidth"/>
              </div>
            </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={adyar4} className="d-block w-100 h-100 img-fluid" alt="adyar4" title="Adyarimages" id="carouselimagewidth"/>
              </div>
            </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar5} className="d-block w-100 h-100 img-fluid" alt="adyar5" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar6} className="d-block w-100 h-100 img-fluid" alt="adyar6" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar7} className="d-block w-100 h-100 img-fluid" alt="adyar7" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar8} className="d-block w-100 h-100 img-fluid" alt="adyar8" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar9} className="d-block w-100 h-100 img-fluid" alt="adyar9" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar10} className="d-block w-100 h-100 img-fluid" alt="adyar10" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar11} className="d-block w-100 h-100 img-fluid" alt="adyar11" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar12} className="d-block w-100 h-100 img-fluid" alt="adyar12" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar13} className="d-block w-100 h-100 img-fluid" alt="adyar13" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar14} className="d-block w-100 h-100 img-fluid" alt="adyar14" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar15} className="d-block w-100 h-100 img-fluid" alt="adyar15" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar16} className="d-block w-100 h-100 img-fluid" alt="adyar16" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={bengaluru1} className="d-block w-100 h-100 img-fluid" alt="bengaluru1" title="Bengaloreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={bengaluru2} className="d-block w-100 h-100 img-fluid" alt="bengaluru2" title="Bengaloreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={bengaluru3} className="d-block w-100 h-100 img-fluid" alt="bengaluru3" title="Bengaloreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={bengaluru4} className="d-block w-100 h-100 img-fluid" alt="bengaluru4" title="Bengaloreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={bengaluru5} className="d-block w-100 h-100 img-fluid" alt="bengaluru5" title="Bengaloreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore1} className="d-block w-100 h-100 img-fluid" alt="coimbatore1" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore2} className="d-block w-100 h-100 img-fluid" alt="coimbatore2" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore3} className="d-block w-100 h-100 img-fluid" alt="coimbatore3" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore4} className="d-block w-100 h-100 img-fluid" alt="coimbatore4" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore5} className="d-block w-100 h-100 img-fluid" alt="coimbatore5" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore6} className="d-block w-100 h-100 img-fluid" alt="coimbatore6" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore7} className="d-block w-100 h-100 img-fluid" alt="coimbatore7" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore9} className="d-block w-100 h-100 img-fluid" alt="coimbatore9" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore10} className="d-block w-100 h-100 img-fluid" alt="coimbatore10" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore11} className="d-block w-100 h-100 img-fluid" alt="coimbatore11" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore12} className="d-block w-100 h-100 img-fluid" alt="coimbatore12" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={delhi1} className="d-block w-100 h-100 img-fluid" alt="delhi1" title="Delhiimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={delhi2} className="d-block w-100 h-100 img-fluid" alt="delhi2" title="Delhiimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum1} className="d-block w-100 h-100 img-fluid" alt="trivandrum1" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum2} className="d-block w-100 h-100 img-fluid" alt="trivandrum2" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum3} className="d-block w-100 h-100 img-fluid" alt="trivandrum3" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum4} className="d-block w-100 h-100 img-fluid" alt="trivandrum4" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum5} className="d-block w-100 h-100 img-fluid" alt="trivandrum5" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum6} className="d-block w-100 h-100 img-fluid" alt="trivandrum6" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum7} className="d-block w-100 h-100 img-fluid" alt="trivandrum7" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum8} className="d-block w-100 h-100 img-fluid" alt="trivandrum8" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum9} className="d-block w-100 h-100 img-fluid" alt="trivandrum9" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={trivandrum10} className="d-block w-100 h-100 img-fluid" alt="trivandrum10" title="Trivandrumimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={namakkal1} className="d-block w-100 h-100 img-fluid" alt="namakkal1" title="Namakkalimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore8} className="d-block w-100 h-100 img-fluid" alt="coimbatore8" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  </div>
</div>
</div>



      {viewallimagesarray.map((item, index)=>(
        <div className={`${styles.imgstyle} col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4`} type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal1"
key={index}>
        <Image src={item.image} onClick={event=>handleSelect1(index)} alt={item.alt}  title={item.title} className="img-fluid w-100" id={item.id} />
      </div>
      ))}
    

    </div>
  </div>


</div>


<div className="tab-pane" id="centre-2">

  <div className="container">
    <div className="row pt-4">


      {/* Modal */}
<div
className="modal fade"
id="SubcriptionConfirmationModal2"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      {/* <p>hello</p> */}
      <Carousel activeIndex={indexAnnanagar} onSelect={handleSelect2} indicators={false}>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={annanagar1} className="d-block w-100 h-100 img-fluid" alt="annanagar1" title="Annanagarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={annanagar2} className="d-block w-100 h-100 img-fluid" alt="annanagar2" title="Annanagarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={annanagar3} className="d-block w-100 h-100 img-fluid" alt="annanagar3" title="Annanagarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  </div>
</div>
</div>

      {annanagarimagesarray.map((item, index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4" 
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal2"
  key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect2(index)}
           className="img-fluid" id={item.id} />
        </div>
      ))}
    </div>
  </div>

</div>

<div className="tab-pane" id="centre-3">


  <div className="container">
    <div className="row pt-4">

    <div
className="modal fade"
id="SubcriptionConfirmationModal3"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      {/* <p>hello</p> */}
      <Carousel activeIndex={indexAdyar} onSelect={handleSelect3} indicators={false}>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar1} className="d-block w-100 h-100 img-fluid" alt="adyar1" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar2} className="d-block w-100 h-100 img-fluid" alt="adyar2" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar3} className="d-block w-100 h-100 img-fluid" alt="adyar3" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar4} className="d-block w-100 h-100 img-fluid" alt="adyar4" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar5} className="d-block w-100 h-100 img-fluid" alt="adyar5" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar6} className="d-block w-100 h-100 img-fluid" alt="adyar6" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar7} className="d-block w-100 h-100 img-fluid" alt="adyar7" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar8} className="d-block w-100 h-100 img-fluid" alt="adyar8" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar9} className="d-block w-100 h-100 img-fluid" alt="adyar9" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar10} className="d-block w-100 h-100 img-fluid" alt="adyar10" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar11} className="d-block w-100 h-100 img-fluid" alt="adyar11" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar12} className="d-block w-100 h-100 img-fluid" alt="adyar12" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar13} className="d-block w-100 h-100 img-fluid" alt="adyar13" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar14} className="d-block w-100 h-100 img-fluid" alt="adyar14" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar15} className="d-block w-100 h-100 img-fluid" alt="adyar15" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={adyar16} className="d-block w-100 h-100 img-fluid" alt="adyar16" title="Adyarimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>

    </div>
  </div>
</div>
</div>

    {adayarimagesarray.map((item, index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal3"
key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect3(index)}
          className="img-fluid" id={item.id} />
        </div>
      ))}


    </div>
  </div>

</div>

<div className="tab-pane" id="centre-4">

  <div className="container">
    <div className="row pt-4">

    <div
className="modal fade"
id="SubcriptionConfirmationModal4"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      {/* <p>hello</p> */}
      <Carousel activeIndex={indexBengaluru} onSelect={handleSelect4} indicators={false}>
          <Carousel.Item>
            <div className="imgWidth">
                <div className="col-12">
                  <Image src={bengaluru1} className="d-block w-100 h-100 img-fluid" alt="bengaluru1" title="Bengaloreimages" id="carouselimagewidth"/>
                </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={bengaluru2} className="d-block w-100 h-100 img-fluid" alt="bengaluru2" title="Bengaloreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={bengaluru3} className="d-block w-100 h-100 img-fluid" alt="bengaluru3" title="Bengaloreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={bengaluru4} className="d-block w-100 h-100 img-fluid" alt="bengaluru4" title="Bengaloreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={bengaluru5} className="d-block w-100 h-100 img-fluid" alt="bengaluru5" title="Bengaloreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
      </Carousel>

    </div>
  </div>
</div>
</div>

    {bengaluruimagesarray.map((item, index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal4"
key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect4(index)}
          className="img-fluid" id={item.id} />
        </div>
      ))}


    </div>
  </div>

</div>

<div className="tab-pane" id="centre-5">

  <div className="container">
    <div className="row pt-4">


    <div
className="modal fade"
id="SubcriptionConfirmationModal5"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      {/* <p>hello</p> */}
      <Carousel activeIndex={indexCoimbatore} onSelect={handleSelect5} indicators={false}>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore1} className="d-block w-100 h-100 img-fluid" alt="coimbatore1" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore2} className="d-block w-100 h-100 img-fluid" alt="coimbatore2" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore3} className="d-block w-100 h-100 img-fluid" alt="coimbatore3" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore4} className="d-block w-100 h-100 img-fluid" alt="coimbatore4" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore5} className="d-block w-100 h-100 img-fluid" alt="coimbatore5" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore6} className="d-block w-100 h-100 img-fluid" alt="coimbatore6" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore7} className="d-block w-100 h-100 img-fluid" alt="coimbatore7" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore9} className="d-block w-100 h-100 img-fluid" alt="coimbatore9" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore10} className="d-block w-100 h-100 img-fluid" alt="coimbatore10" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore11} className="d-block w-100 h-100 img-fluid" alt="coimbatore11" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={coimbatore12} className="d-block w-100 h-100 img-fluid" alt="coimbatore12" title="Coimbatoreimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
          <div className="imgWidth">
            <div className="col-12">
              <Image src={coimbatore8} className="d-block w-100 h-100 img-fluid" alt="coimbatore8" title="Coimbatoreimages" id="carouselimagewidth"/>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>	

    </div>
  </div>
</div>
</div>

    {coimbatoreimagesarray.map((item,index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal5"
key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect5(index)}
          className="img-fluid" id={item.id} />
        </div>
      ))}


    </div>
  </div>

</div>

<div className="tab-pane" id="centre-6">

  <div className="container">
    <div className="row pt-4">

    <div
className="modal fade"
id="SubcriptionConfirmationModal6"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      <Carousel activeIndex={indexDelhi} onSelect={handleSelect6} indicators={false}>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={delhi1} className="d-block w-100 h-100 img-fluid" alt="delhi1" title="Delhiimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={delhi2} className="d-block w-100 h-100 img-fluid" alt="delhi2" title="Delhiimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
      </Carousel>
    </div>
  </div>
</div>
</div>

    {delhiimagesarray.map((item,index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal6"
key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect6(index)}
          className="img-fluid" id={item.id} />
        </div>
      ))}

      

    </div>
  </div>

</div>

<div className="tab-pane" id="centre-7">

  <div className="container">
    <div className="row pt-4">

    <div
className="modal fade"
id="SubcriptionConfirmationModal7"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      {/* <p>hello</p> */}
      <Carousel activeIndex={indexThiruvananthapuram} onSelect={handleSelect7}
        indicators={false}>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum1} className="d-block w-100 h-100 img-fluid" alt="trivandrum1" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum2} className="d-block w-100 h-100 img-fluid" alt="trivandrum2" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum3} className="d-block w-100 h-100 img-fluid" alt="trivandrum3" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum4} className="d-block w-100 h-100 img-fluid" alt="trivandrum4" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum5} className="d-block w-100 h-100 img-fluid" alt="trivandrum5" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum6} className="d-block w-100 h-100 img-fluid" alt="trivandrum6" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum7} className="d-block w-100 h-100 img-fluid" alt="trivandrum7" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum8} className="d-block w-100 h-100 img-fluid" alt="trivandrum8" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum9} className="d-block w-100 h-100 img-fluid" alt="trivandrum9" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={trivandrum10} className="d-block w-100 h-100 img-fluid" alt="trivandrum10" title="Trivandrumimages" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
      </Carousel>

    </div>
  </div>
</div>
</div>

    {trivandrumimagesarray.map((item,index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal7"
key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect7(index)}
          className="img-fluid" id={item.id} />
        </div>
      ))}


    </div>
  </div>

</div>

<div className="tab-pane" id="centre-8">

  <div className="container">
    <div className="row pt-4">

    <div
className="modal fade"
id="SubcriptionConfirmationModal8"
tabIndex="-1"
aria-labelledby="exampleModalCenterTitle"
aria-hidden="true"
>
<div className="modal-dialog modal-dialog-centered" role="document">
  <div className="modal-content p-3">
    <div className="text-end">
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div className="modal-body text-center">
      {/* <p>hello</p> */}
      <Carousel activeIndex={indexNamakkal} onSelect={handleSelect8} indicators={false}>
          <Carousel.Item>
            <div className="imgWidth">
              <div className="col-12">
                <Image src={namakkal1} className="d-block w-100 h-100 img-fluid" alt="Namakkal1" id="carouselimagewidth"/>
              </div>
            </div>
          </Carousel.Item>
      </Carousel>
    </div>
  </div>
</div>
</div>

    {namakkalimagesarray.map((item,index)=>(
        <div className="col-12 col-xl-3 col-lg-4 col-md-6 mb-3 mb-md-4"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#SubcriptionConfirmationModal8"
key={index}
        >
          <Image src={item.image} alt={item.alt}  title={item.title}
          onClick={event=>handleSelect8(index)}
          className="img-fluid" id={item.id} />
        </div>
      ))}


    </div>
  </div>

</div>

<div className="container-fluid" style={{ background: 'transparent linear-gradient(0deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box', opacity: '1' }}>
  <div className="row">
    <div className="col ps-0 pe-0">

      {/* Infrastructure Section */}
      <div className="container">
        <div className="row pt-5">
          <div className="col">
            <h1 className={`${styles.pagemaintitle}`}>Infrastructure Tour</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row pt-3">

          <div className="col-12 col-md-6 mb-4">
            <video width="280px" className="w-100" controls>
              <source src="/coimbatore_video1.mp4"  type="video/mp4" />
            </video>
          </div>

          <div className="col-12 col-md-6 mb-4">
            <video  width="280px" className="w-100" controls>
              <source src="/coimbatore_video2.mp4" type="video/mp4" />
            </video>
          </div>

        </div>
      </div>

    <section id="Hostel">
      {/* Hostel Section */}
      <div className="container">
        <div className="row pt-3">
          <h2 className={`${styles.sectiontitle}  mb-0`}>Hostels</h2>

          <div className="col mb-5">
            <hr /> <p className={`${styles.acheiverrank}  mx-2`}><Image src={hostel1} alt="Hostel icon" title="Hostel" className="img-fluid pe-2" />We provide assistance for accomodations in hostels (boys and girls) located near the institute premises</p>
            <hr />
            <p className={`${styles.acheiverrank}  mx-2`}><Image src={money} alt="Money icon" title="Money" className="img-fluid pe-2" />Per month expenditure would be tentatively Rs 7500/- onwards</p>
            <hr />
            <p className={`${styles.acheiverrank}  mx-2`}><Image src={hostel} alt="Hostel1 icon" title="Hostel1" className="img-fluid pe-2" />Hostel list can be collected from the Admissions Office</p>
            <hr />
            <p className={`${styles.acheiverrank}  mx-2`}><Image src={help} alt="Help icon" title="Help" className="img-fluid pe-2" />Shankar IAS Academy provides only references to the hostels and plays no role in the day-to-day functioning of the hostel.</p>
            <hr />
            <p className={`${styles.acheiverrank}  mx-2`}><Image src={check} alt="Check icon" title="Check" className="img-fluid pe-2" />Selection of the hostel is left to the discretion of the candidate.</p>
            <hr />
          </div>

        </div>
      </div>
    </section>

    </div>
  </div>
</div>

</div>
    </div>

    <Footer />

    

  </>
)
}

export default Infrastructure ;
